import { Box, Card, CardContent, Typography } from "@mui/material";
import { AppLineChart } from "../Charts/LineChart";

export const AverageOrderValue = ({
  totalAvgOrderValue,
  isLoading,
  xAxisData,
  yAxisData,
  dateDifference,
  isCurrency,
}: {
  totalAvgOrderValue: number;
  isLoading: boolean;
  xAxisData: (string | Date | number)[];
  yAxisData: any[];
  dateDifference: number;
  isCurrency: boolean;
}) => {
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" fontWeight={"bold"}>
          Average Order Value =&nbsp;
          <Typography fontWeight={"bold"}>
            ${totalAvgOrderValue.toFixed(2)}
          </Typography>
        </Box>
        <AppLineChart
          isLoading={isLoading}
          xAxisData={xAxisData}
          yAxisData={yAxisData}
          dateDifference={dateDifference}
          isCurrency={true}
        />
      </CardContent>
    </Card>
  );
};
